module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1d8b13b4a4913bad2bbac4ba322dbe87.png";